import React from "react";
import { Link } from "react-router-dom";
import "./style.scss";

import Menu from "../../components/Menu";

import Footer from "../../components/Footer";

import Curiosidades from "../../assets/imagens/Curiosidades-Premio-Ebit-h.619f2332.png";
import Curiosidades01 from "../../assets/imagens/Curiosidades-Premio-Ebit-v.610dce56.png";
import Premio from "../../assets/imagens/Pag-Premio-Ebit-02.png";
import IconAwardsCat3 from "../../assets/imagens/awards/Pag-Premio-Ebit-03.png";
import IconAwardsCat4 from "../../assets/imagens/awards/Pag-Premio-Ebit-04.png";
import IconAwardsCat5 from "../../assets/imagens/awards/Pag-Premio-Ebit-05.png";
import IconAwardsCat6 from "../../assets/imagens/awards/Pag-Premio-Ebit-06.png";
import IconAwardsCat7 from "../../assets/imagens/awards/Pag-Premio-Ebit-07.png";
import IconAwardsCat8 from "../../assets/imagens/awards/Pag-Premio-Ebit-08.png";
import IconAwardsCat9 from "../../assets/imagens/awards/Pag-Premio-Ebit-09.png";
import IconAwardsCat10 from "../../assets/imagens/awards/Pag-Premio-Ebit-10.png";
import IconAwardsCat11 from "../../assets/imagens/awards/Pag-Premio-Ebit-11.png";
import IconAwardsCat12 from "../../assets/imagens/awards/Pag-Premio-Ebit-12.png";
import IconAwardsCat13 from "../../assets/imagens/awards/Pag-Premio-Ebit-13.png";
import IconAwardsCat14 from "../../assets/imagens/awards/Pag-Premio-Ebit-14.png";
import IconAwardsCat15 from "../../assets/imagens/awards/Pag-Premio-Ebit-15.png";

import BannerPremio1 from "../../assets/imagens/Img-banner-Premio-Ebit-02.d37ce8bf.png";
import BannerPremio2 from "../../assets/imagens/Img-banner-Premio-Ebit-03.3de536be.png";
import BannerPremio3 from "../../assets/imagens/Logo-PremioEbit-03.png";

function PremioEbit() {
  return (
    <>
      <Menu></Menu>
      {/* <section className="banner-premio-ebit">
        <div className="banner-premio-ebit__img-premio1">
          <img src={BannerPremio2} alt="Banner Ebit"/>
          <div>
            <img src={BannerPremio1} alt="Segundo Banner Ebit"/>
          </div>
        </div>
      </section> */}
      
      <section>
    <div className="banner-premio2021"></div>
    <div className="bg-text-premio2021">
        <div className="bg-text-premio2021-div1 container">
            <img src={BannerPremio3} alt="Banner Premio Ebit" />
            <div className="bg-text-premio2021-div2" >
                <h1>18º Prêmio <span className="nowrap">Ebit | Nielsen</span>  </h1>
                <h3>Melhores do <span className="nowrap">e-commerce</span></h3>
            </div>
        </div>
    </div>
</section>

      <section className="banner-buttom"></section>

      <section className="pag-awards container">
        <h2>Prêmio Ebit | Nielsen</h2>
        <p className="lead">
          O Prêmio Ebit | Nielsen Melhores do E-commerce é a premiação mais
          tradicional desse segmento. É uma iniciativa da Ebit | Nielsen com o
          propósito de reconhecer lojas online que se destacaram no mercado ao
          longo do ano. Ele é realizado todos os anos e sempre referente ao
          desempenho do ano anterior.
        </p>
        <p className="lead">
          A premiação é feita por avaliação técnica, de acordo com as respostas
          dos consumidores às pesquisas Ebit | Nielsen, e por votação popular,
          na categoria "Lojas Favoritas".
        </p>
        <p className="lead">
          Consulte o regulamento{" "}
          <Link to="/premio-ebit-regulamento">clicando aqui.</Link>
        </p>
        <br />
        <h2>PRÊMIO 2020</h2>
        <p className="lead">
          Devido à pandemia do novo coronavírus, a 17ª edição do Prêmio Ebit |
          Nielsen 2020 ocorreu no dia 27 de Agosto de 2020. Diferentemente de
          todas as outras edições anteriores, a premiação aconteceu de uma
          maneira totalmente online com o objetivo de manter a segurança de
          todos e manter o nosso comprometimento com todos os nossos parceiros,
          colaboradores e clientes.
        </p>
        <p className="lead">
          Na ocasião, premiamos as melhores lojas com base no desempenho de 2019
          nas categorias Melhor Loja Diamante, Top 5 lojas diamante, Melhor
          Experiência Mobile, Lojas Mais Queridas - top 10 mais votadas no geral
          e por categoria (diamante, alimentos e bebidas, bebês e cia, etc.).
        </p>
      </section>

      <section className="banner-secondario ">
        <img src={Premio} alt="" />
        <p>
          {" "}
          <u>
            {" "}
            Confira os ganhadores da última edição{" "}
            <b>
              {" "}
              <a href="https://company.ebit.com.br/premio-ebit/2020">
                clicando aqui!
              </a>
            </b>
          </u>
        </p>
      </section>

      <h2 className="title-cat-awards container">Categorias da premiação</h2>
      <section className="cat-awards container">
        <div className="itens-cat-awards">
          <img src={IconAwardsCat3} alt="" />
          <div>
            <h5>Melhor Loja Diamente</h5>
            <p>Premiação Técnica</p>
          </div>
        </div>

        <div className="itens-cat-awards di-top-5">
          <img src={IconAwardsCat4} alt="" />
          <div>
            <h5>Top 5 Diamante</h5>
            <p>Premiação Técnica</p>
          </div>
        </div>

        <div className="itens-cat-awards">
          <img src={IconAwardsCat5} alt="" />
          <div>
            <h5>Melhor Loja experiência Mobile</h5>
            <p>Premiação Técnica </p>
          </div>
        </div>

        <div className="itens-cat-awards">
          <img src={IconAwardsCat3} alt="" />
          <div>
            <h5>Loja Favorita</h5>
            <p>Votação Popular</p>
          </div>
        </div>

        <div className="itens-cat-awards">
          <img src={IconAwardsCat6} alt="" />
          <div>
            <h5>Top 10 Mais Votadas no Geral</h5>
            <p>Votação Popular</p>
          </div>
        </div>
      </section>
      <div className="container">
        <hr />
      </div>

      <section className="cat-10-voting container">
        <div>
          <img src={IconAwardsCat7} alt="" />
          <h5>Alimentos e Bebidas</h5>
        </div>

        <div>
          <img src={IconAwardsCat8} alt="" />
          <h5>Bebês e Cia</h5>
        </div>

        <div>
          <img src={IconAwardsCat9} alt="" />
          <h5>Casa, Decoração e Ferramentas</h5>
        </div>

        <div>
          <img src={IconAwardsCat14} alt="" />
          <h5>Cosméticos e Perfumaria</h5>
        </div>

        <div>
          <img src={IconAwardsCat13} alt="" />
          <h5>Eletro Eletrônicos</h5>
        </div>

        <div>
          <img src={IconAwardsCat10} alt="" />
          <h5>Livros</h5>
        </div>

        <div>
          <img src={IconAwardsCat15} alt="" />
          <h5>Moda e Acessórios</h5>
        </div>

        <div>
          <img src={IconAwardsCat12} alt="" />
          <h5>Petshop</h5>
        </div>

        <div>
          <img src={IconAwardsCat11} alt="" />
          <h5>Saúde</h5>
        </div>
      </section>

      <h2 className="title-curiosidade container">Curiosidades</h2>

      <div className="curiosidades time-line-ebit container-fluid">
        <div className="container">
          <div className="lt-responsive">
            <img src={Curiosidades} alt="Linha do tempo Ebit" />
          </div>
          <div className="lt-responsive01">
            <img src={Curiosidades01} alt="Linha do tempo Ebit" />
          </div>
        </div>
      </div>

      <Footer></Footer>
    </>
  );
}

export default PremioEbit;



